import { useQuery } from '@zg-rentals/react-query5';
import { useDispatch } from 'react-redux';

import useRequestConfig from '../../hooks/useRequestConfig';

import makeRequest from '../../utils/makeRequestUtils';

import StringConstants from '../../constants/StringConstants';
import { RENTAL_MANAGER_API_V1_PREFIX } from '../../constants/RouteConstants';

type UseGetListingPreviewUrlReturnDataProps = {
  response?: string;
  success: boolean;
  httpStatus: number;
  error?: {
    code: string | number;
    message: string;
  };
};

const API_PREFIX = `${RENTAL_MANAGER_API_V1_PREFIX}/users/properties/preview/getListingPreviewUrl`;

const useGetListingPreviewUrl = (listingAlias: string, queryOptions = {}) => {
  const dispatch = useDispatch();
  const requestConfig = useRequestConfig(StringConstants.GET);

  const queryFn = (): Promise<string> =>
    makeRequest<UseGetListingPreviewUrlReturnDataProps>({
      dispatch,
      endpoint: API_PREFIX,
      requestConfig,
      config: { params: { listingAlias }, timeout: 5000 },
    });

  return useQuery({
    queryKey: ['getListingPreviewUrl', listingAlias],
    queryFn,
    staleTime: 10 * 1000,
    ...queryOptions,
    enabled: Boolean(listingAlias),
  });
};

export { useGetListingPreviewUrl };
